import React from "react";
export default function ShieldIcon({ className = "", size = 24, color = "#0AAF62", }) {
    return (React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: className },
        React.createElement("path", { d: "M12 2.5L4.5 6V11C4.5 15.5 7.5 19.5 12 21C16.5 19.5 19.5 15.5 19.5 11V6L12 2.5Z", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
}
